import React from 'react';
import authRoles from '@/app/auth/authRoles';
import Schools from './Schools';
import AddSchools from './AddSchools';
import EditSchools from './EditSchools';

const SchoolsConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/schools',
			// component: Schools,
			element: (
				<React.Suspense fallback={<>...</>}>
					<Schools />
				</React.Suspense>
			),
		},
		{
			path: '/addschool',
			// component: AddSchools,
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddSchools />
				</React.Suspense>
			),
		},
		{
			path: '/editschool/:id',
			// component: EditSchools,
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditSchools />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.admin,
};

export default SchoolsConfig;
